import localStorageUtil from '@/utils/localStorageUtil'

export default {

  state: {
    authorized: !(localStorageUtil.getToken() == null),
    userEmail: localStorageUtil.getUserEmail(),
    userProvider: localStorageUtil.getUserProvider()
  },

  mutations: {

    setAuthorized (state, authorizedStatus) {
      state.authorized = authorizedStatus
    },

    setUserEmail (state, userEmail) {
      state.userEmail = userEmail
    },

    setUserProvider (state, userProvider) {
      state.userProvider = userProvider
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js